import React, { ReactElement } from 'react';
import { IconProps } from '../../../../types';

const GridIcon = ({ className = 'w-6 h-6' }: IconProps): ReactElement => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
  >
    <path d="M19.4671 2.39996C20.6453 2.39996 21.6004 3.34201 21.6004 4.50407L21.6004 8.0959C21.6004 9.25796 20.6453 10.2 19.4671 10.2H16.2671C15.0889 10.2 14.1337 9.25796 14.1337 8.09589L14.1337 4.50407C14.1337 3.34201 15.0888 2.39996 16.2671 2.39996L19.4671 2.39996Z" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.53372 2.39996C3.35552 2.39996 2.40039 3.34201 2.40039 4.50407L2.4004 8.0959C2.4004 9.25796 3.35553 10.2 4.53373 10.2H7.73373C8.91194 10.2 9.86706 9.25796 9.86706 8.09589L9.86705 4.50407C9.86705 3.34201 8.91193 2.39996 7.73372 2.39996L4.53372 2.39996Z" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.53373 13.8C3.35553 13.8 2.4004 14.742 2.4004 15.9041L2.4004 19.4959C2.4004 20.658 3.35553 21.6 4.53374 21.6H7.73373C8.91194 21.6 9.86707 20.658 9.86707 19.4959L9.86706 15.9041C9.86706 14.742 8.91194 13.8 7.73373 13.8H4.53373Z" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 14V22" strokeWidth="2" strokeLinecap="round" />
    <path d="M22 18H14" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default GridIcon;
